import {
  EventSchedule,
  TournamentsQueryParams,
  TournamentsResponse,
} from '@fantaz/shared/data-access/models';
import { createAction, props } from '@ngrx/store';

export const loadTournaments = createAction(
  '[Tournament Page] Load Tournaments',
  props<{ params: TournamentsQueryParams }>(),
);

export const loadTournamentsSuccess = createAction(
  '[Tournament/API] Load Tournaments Success',
  props<{
    cashTournaments: TournamentsResponse;
    prizeTournaments: TournamentsResponse;
  }>(),
);

export const loadTournamentsFailure = createAction(
  '[Tournament/API] Load All Tournaments Failure',
  props<{ error: any }>(),
);

export const loadMoreTournaments = createAction(
  '[Tournament Page] Load More Tournaments',
  props<{ params: TournamentsQueryParams }>(),
);

export const loadMoreTournamentsSuccess = createAction(
  '[Tournament/API] Load More Tournaments Success',
  props<{
    cashTournaments: TournamentsResponse;
    prizeTournaments: TournamentsResponse;
  }>(),
);

export const loadMoreTournamentsFailure = createAction(
  '[Tournament/API] Load More Tournaments Failure',
  props<{ error: any }>(),
);

export const loadPageTournaments = createAction(
  '[Tournament Page] Load Page Tournaments',
  props<{ params: TournamentsQueryParams }>(),
);

export const loadPageTournamentsSuccess = createAction(
  '[Tournament/API] Load Page Tournaments Success',
  props<{
    cashTournaments: TournamentsResponse;
    prizeTournaments: TournamentsResponse;
  }>(),
);

export const loadPageTournamentsFailure = createAction(
  '[Tournament/API] Load Page Tournaments Failure',
  props<{ error: any }>(),
);

export const filterTournaments = createAction(
  '[Tournament Page] Filter Tournaments',
  props<{ params: TournamentsQueryParams }>(),
);

export const filterTournamentsSuccess = createAction(
  '[Tournament/API] Filter Tournaments Success',
  props<{
    cashTournaments: TournamentsResponse;
    prizeTournaments: TournamentsResponse;
  }>(),
);

export const filterTournamentsFailure = createAction(
  '[Tournament/API] Filter Tournaments Failure',
  props<{ error: any }>(),
);

export const clearFilterTournamentsByGames = createAction(
  '[Tournament Page] Clear Filter By Games',
);

export const clearFilterTournamentsByTags = createAction(
  '[Tournament Page] Clear Filter By Tags',
);

export const searchTournaments = createAction(
  '[Tournament Page] Search',
  props<{ searchTerm: string }>(),
);

export const loadSubscriptionTournament = createAction(
  '[Tournament Page] Load Subscription Tournament',
  props<{ eventPrototypeUuid: string; eventSchedule: EventSchedule }>(),
);

export const loadSubscriptionTournamentSuccess = createAction(
  '[Tournament Page] Load Subscription Tournament Success',
  props<{
    eventPrototypeUuid: string;
    eventSchedule: EventSchedule;
    status: boolean;
  }>(),
);

export const clearSearchTournaments = createAction(
  '[Tournament Page] Clear Search',
);

export const clearAllFilters = createAction(
  '[Tournament Page] Clear All Filters',
);

export const loadSubscriptionTournamentFailure = createAction(
  '[Tournament/API] Load Tournament Failure',
  props<{ error: any }>(),
);

export const clearRoomFilters = createAction('[Tournament Page] Clear Filters');
